// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"cdccf2b4","741":"cf864648"}[chunkId] + ".chunk.js";
};